import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const defaultSettings = {
  platformName: 'MyAccidentEstimator',
  platformTagline: 'Free Accident Settlement Estimator',
  companyName: 'MyAccidentEstimator',
};

export function usePlatformSettings() {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, 'platformSettings', 'config');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setSettings({ ...defaultSettings, ...docSnap.data() });
        } else {
          // Create default settings if they don't exist
          await setDoc(docRef, defaultSettings);
          setSettings(defaultSettings);
        }
      } catch (err) {
        console.error('Error fetching platform settings:', err);
        setError(err);
        // Use defaults on error
        setSettings(defaultSettings);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const updateSettings = async (newSettings) => {
    try {
      const docRef = doc(db, 'platformSettings', 'config');
      const updatedSettings = { ...settings, ...newSettings };
      await setDoc(docRef, updatedSettings, { merge: true });
      setSettings(updatedSettings);
      return true;
    } catch (err) {
      console.error('Error updating platform settings:', err);
      setError(err);
      return false;
    }
  };

  return { settings, loading, error, updateSettings };
}

export default usePlatformSettings;

